import React from 'react';
import PropTypes from 'prop-types';

export const TileGridSkeletonPlaceholder = ({ tilesCount }) => {
  // Generate array for remaining tiles (total - 1 for the first span-2 tile)
  const remainingTiles = Array.from({ length: Math.max(0, tilesCount - 1) }, (__, i) => i);

  const baseTileClasses = [
    'sui-border-1',
    'sui-border-solid',
    'sui-border-primary',
    'sui-rounded-lg',
    'sui-p-2',
    'sui-bg-primary',
    'sui-animate-pulse'
  ].join(' ');
  const firstTileClasses = `sui-col-span-2 ${baseTileClasses}`;

  return (
    <div className="sui-bg-strong sui-p-3">
      <div className="sui-grid sui-gap-2 sui-grid-cols-2">
        {/* First tile spans 2 columns */}
        <div className={firstTileClasses}>
          <div className="sui-flex sui-flex-col sui-gap-1">
            <div className="sui-h-3 sui-bg-strong sui-rounded sui-w-1/3" />
            <div className="sui-h-4 sui-bg-strong sui-rounded sui-w-2/3" />
          </div>
        </div>
        {/* Remaining tiles */}
        {remainingTiles.map((i) => (
          <div key={i} className={baseTileClasses}>
            <div className="sui-flex sui-flex-col sui-gap-1">
              <div className="sui-h-3 sui-bg-strong sui-rounded sui-w-1/2" />
              <div className="sui-h-4 sui-bg-strong sui-rounded sui-w-3/4" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

TileGridSkeletonPlaceholder.propTypes = {
  tilesCount: PropTypes.number
};

TileGridSkeletonPlaceholder.defaultProps = {
  tilesCount: 5
};